import { Button } from '@uchi/dino-button';
import { Input } from '@uchi/dino-input';
import { Text } from '@uchi/dino-text';
import { useCallback, useEffect, useState, type FormEvent } from 'react';
import type { Credentials } from '~/shared/types';
import './AuthForm.css';
import { UCHI_HOST_URL } from '~/shared/lib/env/envVariables';

interface AuthForm {
  onSubmit: (credentials: Credentials) => Promise<void>;
  error?: string;
}

const forgetPasswordUrl = UCHI_HOST_URL.concat('/forget_password');

export function AuthForm({ onSubmit, error }: AuthForm) {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [formError, setFormError] = useState('');

  const onSubmitHandler = useCallback(
    async (e: FormEvent<HTMLFormElement>) => {
      e.preventDefault();

      if (!login || !password) {
        setFormError('Введите логин и пароль');
        return;
      }

      setLoading(true);

      await onSubmit({
        login,
        password,
      });

      setLoading(false);
    },
    [onSubmit, password, login],
  );

  useEffect(() => {
    setFormError(error ?? '');
  }, [error]);

  return (
    <form onSubmit={onSubmitHandler} className="auth-form">
      <div className="auth-form_container">
        <Text variant="h3" as="h3" className="auth-form_title">
          Вход
        </Text>
        <Input
          id="login"
          value={login}
          onChange={setLogin}
          tabIndex={1}
          placeholder="Логин"
          className="auth-form_input"
          fluid
        />
        <Input
          id="password"
          value={password}
          onChange={setPassword}
          tabIndex={1}
          placeholder="Пароль"
          className="auth-form_input"
          password
          fluid
        />
        {formError && <Text color="color-system-error-base">{formError}</Text>}
        <Button type="submit" fluid loading={loading}>
          Войти
        </Button>
        <a href={forgetPasswordUrl} className="auth-form_forgot-password" tabIndex={2}>
          Забыли пароль?
        </a>
      </div>
    </form>
  );
}
